import React, { FC, useMemo } from 'react';
import { Section } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { P } from 'ia-react-core';
import { PersonalInformation } from '../../../../interfaces/PersonalInformation';

export interface CorrespondenceProps {
  personalInfo: PersonalInformation;
}
const Correspondence: FC<CorrespondenceProps> = ({ personalInfo }) => {
  const { t } = useTranslation('PersonalInformationsTile');
  const language = useMemo(() => personalInfo?.correspondence?.language, [personalInfo]);

  if (!personalInfo) return null;
  if (!personalInfo.correspondence) return null;
  if (personalInfo.correspondence.language === '') return null;
  if (!personalInfo.correspondence.behaviours.showSection) return null;

  return (
    <Section name={t('correspondence.label')}>
      <P>{t(`correspondence.${language}`)}</P>
    </Section>
  );
};
export default Correspondence;
